import defaultScene from './DefaultScene/DefaultScene';
import { SceneProps } from './scene-utils';
import { Scene, SceneRegister } from './types';
import StopeSelectedView from './StopeSelectedScene/StopeSelectedScene';
import WearMonitoringView from './WearMonitoringScene/WearMonitoringScene';
import ManuelNodesScene from './ManuelNodesScene/ManuelNodesScene';
import StopeFillScene from './StopeFillScene/StopeFillScene';
import BulkImportSolidsScene from './BulkImportSolidsScene/BulkImportSolidsScene';
import BulkEditScene from './BulkEditScene/BulkEditScene';
import ScenarioManagerScene from './ScenarioManagerScene/ScenarioManagerScene';

const SCENE_DICTIONARY: Record<SceneRegister, (props: SceneProps) => Scene> = {
  DEFAULT: defaultScene,
  WEAR_MONITORING: WearMonitoringView,
  STOPE_SELECTED: StopeSelectedView,
  MANUEL_NODES: ManuelNodesScene,
  STOPE_FILL: StopeFillScene,
  BULK_IMPORT_SOLIDS: BulkImportSolidsScene,
  BULK_EDIT: BulkEditScene,
  SCENARIO_MANAGER: ScenarioManagerScene,
};

export default SCENE_DICTIONARY;
